import React from 'react';
import { Config } from './Config';
import { CURRENCY_FORMATS } from './CurrencyFormats';

const MAX_CALENDAR_FARES_DIGITS = 4;

export const getRoundedAmount = (amount) => (amount ? Math.ceil(amount) : 0);

const buildFallbackFormat = ({ currencySymbol = '', currencyPosition = 'back' } = {}) => ({
    prefix: currencyPosition === 'front' ? currencySymbol : '',
    suffix: currencyPosition !== 'front' ? currencySymbol : '',
    needsWhiteSpace: true,
});

export const CurrencyUtils = () => {
    const i18nCurrency = Config.get('i18n').currency || {};
    const lang = (Config.get('lang') || '').toLowerCase();

    const currencyFormat = CURRENCY_FORMATS[lang]
        || CURRENCY_FORMATS[Object.keys(CURRENCY_FORMATS).find((key) => key === lang.substring(0, 2))]
        || buildFallbackFormat(i18nCurrency);

    const { prefix = '', suffix = '', needsWhiteSpace = false } = currencyFormat || {};

    const shouldShowAmount = (amount) => {
        if (Number.isNaN(Number(amount))) return false;
        return getRoundedAmount(amount).toString().length <= MAX_CALENDAR_FARES_DIGITS;
    };

    const parseAmount = (amount) => {
        let parsedAmount;
        try {
            parsedAmount = new Intl.NumberFormat(lang, {
                style: 'decimal',
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
            }).format(amount);
        } catch {
            parsedAmount = new Intl.NumberFormat('en', {
                style: 'decimal',
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
            }).format(amount);
        }
        return parsedAmount;
    };

    const addWhiteSpace = (symbol) => (needsWhiteSpace && symbol ? ' ' : '');

    const formatCurrency = (amount) => {
        const parsedAmount = parseAmount(getRoundedAmount(amount));
        return `${prefix}${addWhiteSpace(prefix)}${parsedAmount}${addWhiteSpace(suffix)}${suffix}`;
    };

    const getFormattedCalendarFares = (amount) => {
        const orderedDisplayAmount = formatCurrency(amount);
        if (shouldShowAmount(amount)) return <span dangerouslySetInnerHTML={{ __html: `${orderedDisplayAmount}` }} />;
        return <div className="odf-icon odf-icon-s odf-icon-more" style={{ display: 'block' }} />;
    };

    return {
        getRoundedAmount,
        shouldShowAmount,
        formatCurrency,
        getFormattedCalendarFares,
    };
};
